import React from 'react'
import { useSelector } from 'react-redux'
import { lang } from 'utils/helpers'
import { getStaticImage } from 'utils/statics'

const ThreadsContainer = ({ openPage }) => {
  const { inchat: { thread } } = useSelector(store => store)

  return (
    <div className='inchat-container inchat-threads-container'>
      <div className='inchat-container__header' onClick={() => openPage('threads')}>
        <img src={getStaticImage('/icons/orange-brand/icon-threads.svg')} alt='threads' />
        <span className='inchat-container__title'>{lang('inchat_threads')}</span>
        { thread > 0 &&
          <div className='inchat-container__count'>
            <span>{thread}</span>
          </div>
        }
      </div>
    </div>
  )
}

export default ThreadsContainer
